export const FORM_VIEW = "forms";
export const QUESTION_VIEW = "questions";
export const CUSTOMER_VIEW = "customers";
export const REPORT_VIEW = "reports";
export const USER_VIEW = "users";
export const ECONOMY_VIEW = "economy";
export const TRAIT_VIEW = "traits";
export const HELP_VIEW = "help";
